import { defineComponent as _defineComponent } from 'vue';
import Button from 'primevue/button';
import { useMitt } from '../../../../Plugins/mitt';
import { concatPlotsCodes } from '../../../../Services/Utils';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Details',
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const emitter = useMitt();
        const edit = () => emitter.emit('open-irrigation-form', props.data);
        // emitter.on('irrigation-saved', (data) => Object.assign(props.data, data));
        const __returned__ = { emitter, props, edit, get Button() { return Button; }, get concatPlotsCodes() { return concatPlotsCodes; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
